<div class="message-container">
  <app-message *ngFor="let msg of lista" [message]="msg"></app-message>
</div>
